module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABYElEQVRIS7XVzSsEYRzA8e8zszM5uZCDIntRTt6SmzNFWhcpHGzKcUWuJCebi40cnFxcJG4OnHGlHFaRkuKyl9UyMzujHe1m7dszuzPzB3y+z/Nren6CAL/MUue6CMrP4cBGIIE8nju874G/uO+B/7ivgXK4b4FKuC+BanjDgVp4QwEZvO6ALF5XwAvuOeAV9xSQxZW+Ucha2PeX7jMn9VRI44MT6NEEjpHhO9YjF5DFRXgAPXaM0Jswz7fJXuzVDpR9W9rChMaXsa4OcV7ufpGWDvS1M0RzK9b1CdbRSmELVBxRpZOrI3NoM1s4X2nM/QXs1wf01VOU9m7s5A3G7ixkzeqBqmNRNbRoArV/zJ2185ZE6erFfn/CiE/BZ6poh5XcQGrmioo2v4M6HHExJ53CiEdwPp5LFmRRQArPE0IQmt5EHZrEPFjEfrwtu30LAU+4h0XuBoLC3T8sSDwX+AEMz4Y5GYxKmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhifu/pay_icon_mode_sel.png
// module id = 0R8p
// module chunks = 1